module.exports = __webpack_public_path__ + "img/select_toggle.5f01d099.svg";